if ( typeof ProductPage !== 'function' ) {

    class ProductPage extends HTMLElement {

        constructor(){

            super();

            this.productGallery = this.querySelector('[data-js-product-gallery]');
            this.productSlider = this.querySelector('css-slider');

            // Gallery thumbnails

            if ( this.productSlider ) {

                const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

                if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

                    this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
                        if ( i == 0 )  {
                            elm.classList.add('active');
                        }
                        elm.addEventListener('click',e=>{
                            if ( this.productSlider.sliderEnabled ) {
                                this.productSlider.changeSlide(e.currentTarget.dataset.index);
                            } else {
                                /* MODIFICA FADE (1/3): Disabilita scroll su click thumbnail */
                                /*
                                window.scrollTo({
                                    top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
                                    behavior: 'smooth'
                                });
                                */
                                this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
                            }
                            this._pauseAllMedia();
                            this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
                            productGaleryThumbnails.scrollTo({
                                left: elm.offsetLeft - 50,
                                behaviour: 'smooth'
                            })
                        });
                    })

                    this.productSlider.addEventListener('change', e=>{
                        this.thumbnailNavigationHelper(e.target.index);
                    });

                }

                this.productSlider.addEventListener('navigation', e=>{
                    this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
                })
                this.productSlider.addEventListener('change', e=>{
                    this._pauseAllMedia();
                    if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
                        if ( this.xrButton ) {
                            this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
                        }
                        setTimeout(()=>{
                            this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
                        }, 150);
                    }
                });

                // Parallax

                this.productSlider.addEventListener('ready', (e)=>{
                    
                    if ( this.firstProductGalleryIndex ) {
                        this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
                    }

                    const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
                    const productFigures = this.querySelectorAll('.apply-gallery-animation');
                    this.productSlider.addEventListener('scroll', ()=>{
                        const scrollX = -this.productSlider.element.scrollLeft;
                        productSlides.forEach((slide,i)=>{
                            const media = productFigures[i];
                            if ( media ) {
                                /* MODIFICA FADE (2/3): Commenta l'effetto parallax che causa il reset */
                                /* media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`; */
                            }
                        });
                    });

                });

            }

            // show cart drawer when element is added to cart

            if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
                
                let addToCartEnter = false;
                if ( this.querySelector('[data-js-product-add-to-cart]') ) {
                    this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
                        if ( e.keyCode == window.KEYCODES.RETURN ) {
                            addToCartEnter = true;
                        }
                    })
                }   

                if ( this.querySelector('[data-js-product-form]') ) {
                    this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
                        document.getElementById('site-cart-sidebar').show();
                        if ( document.getElementById('cart-recommendations') ) {
                            document.getElementById('cart-recommendations').generateRecommendations();
                        }
                        if ( addToCartEnter ) {
                            setTimeout(()=>{
                                document.querySelector('#site-cart-sidebar [data-js-close]').focus();
                            }, 200);
                        }
                    });
                }

            }

            // Check for models

            const models = this.querySelectorAll('product-model');
            if ( models.length > 0 ) {
                window.ProductModel.loadShopifyXR();
                this.xrButton = this.querySelector('.product-gallery__view-in-space');
            }

            // hide buy now button if stock disabled

            const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
            if ( addToCartButton ) {
                if ( addToCartButton.classList.contains('disabled') ) {
                    this.querySelector('product-form').classList.add('disable-buy-button');
                } else {
                    this.querySelector('product-form').classList.remove('disable-buy-button');
                }
                const buyObserver = new MutationObserver(()=>{
                    if ( addToCartButton.classList.contains('disabled') ) {
                        this.querySelector('product-form').classList.add('disable-buy-button');
                    } else {
                        this.querySelector('product-form').classList.remove('disable-buy-button');
                    }
                });
                buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
            }


            // Product variant event listener for theme specific logic

            this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
            if ( this.productVariants ) {
                this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
                this.onVariantChangeHandler({target:this.productVariants});
            }

        }

        thumbnailNavigationHelper(index=0){
            this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
                if ( i == index )
                    elm.classList.add('active');
                else 
                    elm.classList.remove('active');
            });
        }

        onVariantChangeHandler(e){

            let variant = e.target.currentVariant;
            if ( variant ) {
                
                // image handling

                this.productGallery = this.querySelector('[data-js-product-gallery]');
                if ( variant.featured_media != null && this.productGallery ) {
                    let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
                    if ( variantImg ) {
                        if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
                            if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
                                this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
                            } else {
                                this.firstProductGalleryIndex = variantImg.dataset.index;
                            }
                        } else {
                            /* MODIFICA FADE (3/3): Disabilita scroll su cambio Variante */
                            /*
                            window.scrollTo({
                                top: variantImg.offsetTop,
                                behavior: 'smooth'
                            });
                            */
                        }
                    }
                }

            }
            
        }

        _pauseAllMedia(){

            document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
                video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
            });
            document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
                video.contentWindow.postMessage('{"method":"pause"}', '*');
            });
            document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
            document.querySelectorAll('.product-gallery product-model').forEach(model => {
                if ( model.modelViewerUI ) 
                    model.modelViewerUI.pause()
            });
        }
        
        _playMedia(media){
            switch ( media.dataset.productMediaType ) {
                case 'video':
                    if ( media.querySelector('video') ) {
                        media.querySelector('video').play();
                    }
                    break;
                case 'external_video-youtube':
                    if ( media.querySelector('.js-youtube') ) {
                        media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
                    }
                    break;
                case 'external_video-vimeo':
                    if ( media.querySelector('.js-vimeo') ) {
                        media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
                    }
                    break;
            }
        }

    }

  if ( typeof customElements.get('product-page') == 'undefined' ) {
        customElements.define('product-page', ProductPage);
    }

}
/* * ------------------------------------------------------------------
 * INIZIO SCRIPT CUSTOM PER VARIANTI IBRIDE (FIX V25 - Quick View Watcher)
 * Include: Filtro Gusti Dinamico + Patch Scroll + Observer per Popup
 * ------------------------------------------------------------------
 */

// --- FUNZIONE 1: GESTIONE VARIANTI (LOGICA FILTRO) ---
function initializeCustomVariantLogic() {
  // Cerca TUTTI i selettori (Pagina Prodotto + Quick View Modals)
  // Nota: Cerchiamo anche dentro 'product-variants' generici per sicurezza
  const allPickers = document.querySelectorAll('product-variants');

  allPickers.forEach(productVariantPicker => {
    
    // ** PROTEZIONE (GUARD) **
    // Se abbiamo già inizializzato questo blocco, saltalo.
    if (productVariantPicker.dataset.customLogicInitialized === 'true') {
      return;
    }

    // --- 1. IDENTIFICAZIONE ELEMENTI ---
    // Cerchiamo i selettori. Se non hanno gli attributi custom, proviamo a indovinarli dall'ordine (fallback)
    let formatoSelect = productVariantPicker.querySelector('[data-custom-formato-select]');
    let gustiSelect = productVariantPicker.querySelector('[data-custom-gusti-select]');
    
    // FALLBACK: Se mancano gli attributi data-custom, assumiamo che:
    // La prima select è il Formato (Opzione 1), la seconda è il Gusto (Opzione 2)
    const allSelects = productVariantPicker.querySelectorAll('select');
    if (!formatoSelect && allSelects.length > 0) formatoSelect = allSelects[0];
    if (!gustiSelect && allSelects.length > 1) gustiSelect = allSelects[1];

    const gustiContainer = gustiSelect ? gustiSelect.closest('.product-variant__item') || gustiSelect.parentNode : null;
    const allVariantsData = productVariantPicker.querySelector('[data-all-variants-json]') || productVariantPicker.querySelector('[type="application/json"]');

    // Se mancano i pezzi fondamentali, esci.
    if (!formatoSelect || !gustiSelect || !allVariantsData) {
      return; 
    }

    // Marca come inizializzato ORA, prima di eseguire, per evitare doppi binding
    productVariantPicker.dataset.customLogicInitialized = 'true';

    // --- 2. LOGICA FILTRO GUSTI ---
    let allVariants = [];
    try {
      allVariants = JSON.parse(allVariantsData.textContent);
    } catch (e) {
      console.error('Script Varianti Custom: JSON Errato.', e);
      return;
    }
    
    // Salviamo tutte le opzioni originali del gusto
    const allGustiOptions = Array.from(gustiSelect.querySelectorAll('option'));

    const updateGustiAvailability = () => {
      const selectedFormato = formatoSelect.value;
      
      // Nascondi/Mostra intero contenitore gusti se necessario
      if (gustiContainer) {
         gustiContainer.style.display = selectedFormato ? 'block' : 'none';
      }
      
      let firstAvailableValue = null;
      const currentGustoValue = gustiSelect.value; 
      let isCurrentValueValid = false;
      
      allGustiOptions.forEach(option => {
        const gustoValue = option.value;
        
        // Trova se esiste una variante con: Formato Selezionato + Questo Gusto
        // Nota: Adatta option1/option2 in base al tuo ordine reale su Shopify
        const matchingVariant = allVariants.find(variant => {
          // Controllo incrociato: a volte option1 è gusto, a volte formato. 
          // Assumiamo: Formato = option1, Gusto = option2 (Standard)
          return (variant.option1 === selectedFormato && variant.option2 === gustoValue) ||
                 (variant.option2 === selectedFormato && variant.option1 === gustoValue); 
        });

        // Se esiste ed è disponibile (o gestita da magazzino)
        if (matchingVariant && (matchingVariant.available || !matchingVariant.inventory_management || matchingVariant.inventory_policy === 'continue')) {
          // MOSTRA
          option.style.display = 'block';
          option.disabled = false;
          if (!firstAvailableValue) firstAvailableValue = gustoValue;
          if (gustoValue === currentGustoValue) isCurrentValueValid = true;
        } else {
          // NASCONDI
          option.style.display = 'none';
          option.disabled = true;
        }
      });
      
      // --- 3. AUTO-SELEZIONE ---
      // Se il gusto che avevo selezionato è sparito (non esiste per questo formato),
      // seleziona automaticamente il primo disponibile.
      if (!isCurrentValueValid && firstAvailableValue) {
         gustiSelect.value = firstAvailableValue;
         // Dispatcha l'evento per dire a Shopify che è cambiato il gusto
         gustiSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    // Attiva listener
    formatoSelect.addEventListener('change', updateGustiAvailability);
    
    // Esegui subito al caricamento
    updateGustiAvailability();
  });
}

// --- FUNZIONE 2: FIX SCROLL MOBILE ---
function findAndPatchSlider() {
  document.querySelectorAll('.css-slider-viewport:not([data-scroll-patched])').forEach(sliderViewport => {
      sliderViewport.dataset.scrollPatched = 'true';
      const originalScrollTo = sliderViewport.scrollTo.bind(sliderViewport);
      sliderViewport.scrollTo = function(options) {
        if (window.innerWidth <= 768 && typeof options === 'object' && options?.behavior === 'smooth') {
          options.behavior = 'auto';
        }
        originalScrollTo(options);
      };
  });
}


// --- FUNZIONE 3: OBSERVER PER QUICK VIEW (IL CUORE DEL FIX) ---
function startQuickViewObserver() {
  // Questa sentinella osserva il BODY per vedere se vengono aggiunti nuovi nodi (il popup)
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
            // Se il nodo aggiunto è un modal o contiene product-variants
            if (node.nodeType === 1 && (node.tagName === 'MODAL-BOX' || node.querySelector('product-variants'))) {
                shouldUpdate = true;
            }
        });
      }
    });
    
    if (shouldUpdate) {
        // Dai tempo al DOM di renderizzare (50ms) poi lancia lo script
        setTimeout(() => {
            initializeCustomVariantLogic();
            findAndPatchSlider();
        }, 50);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}


// --- ESECUZIONE ---
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeCustomVariantLogic();
    findAndPatchSlider();
    startQuickViewObserver(); // Avvia la sentinella
  });
} else {
  initializeCustomVariantLogic();
  findAndPatchSlider();
  startQuickViewObserver(); // Avvia la sentinella
}

/* * FINE SCRIPT CUSTOM */
